module.exports = __webpack_public_path__ + "img/help2-1-2.7e4de5f8.png";